import * as types from './mutation-types'

export default {
  [types.BOOTSTRAP_FINANCES_FORMS] (state, financesForms) {
    state.financesForms = financesForms
  },
  [types.SET_TOTAL_FINANCES_FORMS] (state, totalFinancesForms) {
    state.totalFinancesForms = totalFinancesForms
  },
  [types.ADD_FINANCES_FORMS] (state, data) {
    state.financesForms.push(data.financesForm)
  },
  [types.SET_SELECT_ALL_STATE] (state, data) {
    state.selectAllField = data
  },
  [types.UPDATE_FINANCES_FORMS] (state, data) {
    let financesForm = state.financesForms.findIndex(financesForm => financesForm.id === data.financesForm.id)
    state.financesForms[financesForm] = data.financesForm
  }
}
